import userinfo from './userinfo'
export default {
  modules: {
    userinfo
  }
}


// WEBPACK FOOTER //
// ./src/stores/index.js